async function getCpt(param) {
  const response = await fetch(
    'https://admin.hullo.pl' + '/wp-json/wp/v2/' + param
  );
  // console.log('https://admin.hullo.pl' + '/wp-json/wp/v2/' + param);
  return await response.json();
}

export default getCpt;
